// What a node can (DECISIONS 2026-10-17 "nodes behind central"): through
// central a node's page is central's build, so a control whose feature the
// node does not list is shown off, saying why; the node's own page is its
// own build and has every feature (features: null).

// nodeFeatures: what the node behind this page can. null: every feature
// (the node's own page, or not known yet: nothing is turned off while it
// loads). The node's status lists them from the list on; central's record
// has them for a node from before it (inferred from its version).
export function nodeFeatures(
    viaCentral: boolean,
    status: readonly string[] | undefined,
    info: { features: string[] } | null,
): string[] | null {
    if (!viaCentral) return null
    if (status?.length) return [...status]
    return info ? info.features : null
}

// hasFeature: a gate. Its name is a literal at every call, so
// TestFeatureGatesListed (internal/node) holds it to the node's list.
export function hasFeature(features: readonly string[] | null, name: string): boolean {
    return features === null || features.includes(name)
}

// needsNewer: why a control is off, with what the node runs and the first
// version central keeps that has the feature
export function needsNewer(version: string | undefined, first: string | undefined): string {
    const runs = version ? `this node runs ${version}` : 'this node runs an older version'
    return `Needs a newer node version: ${runs}${first ? `; ${first} and later have it` : ''}.`
}
